import { useRef, useState } from 'react'

const useChatTextInput = () => {
  const [input, setInput] = useState('')
  const inputRef = useRef(null)

  const handleInputChange = (event) => {
    setInput(event.target.value)

    const element = inputRef.current

    if (element) {
      element.style.height = 'auto'
      element.style.height = `${Math.min(element.scrollHeight, 120)}px`
    }
  }

  const clearInput = () => {
    setInput('')

    if (inputRef.current) {
      inputRef.current.style.height = 'auto'
    }
  }

  return {
    input,
    inputRef,
    handleInputChange,
    clearInput,
  }
}

export default useChatTextInput